export default {
  data () {
    return {
      panelOpen: {},
      panelGroups: {}
    }
  },
  computed: {
    slideTransition() {
      return {
        beforeEnter: this.beforeEnter,
        enter: this.enter,
        afterEnter: this.afterEnter,
        beforeLeave: this.beforeLeave,
        leave: this.leave,
        afterLeave: this.afterLeave
      }
    }
  },
  methods: {
    isPanelOpen (panel, index) {
      if ('overrideIsPanelOpen' in this && typeof this.overrideIsPanelOpen === 'function') {
        return this.overrideIsPanelOpen(panel, index)
      }
      return this.panelOpen[panel]
    },
    togglePanel (panel) {
      if (this.panelGroups[panel] !== '*') {
        Object.keys(this.panelOpen).forEach(key => {
          if (key !== panel) {
            if (!this.panelGroups[key] || this.panelGroups[key] === this.panelGroups[panel]) {
              this.panelOpen[key] = false
            }
          }
        })
      }
      this.panelOpen[panel] = !this.isPanelOpen(panel)
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el, done) {
      // Force a reflow
      el.offsetHeight
      
      // Get the actual content height
      el.style.height = 'auto'
      const height = el.offsetHeight
      el.style.height = '0'
      
      // Force another reflow
      el.offsetHeight
      
      // Animate to the actual height
      el.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out'
      el.style.height = height + 'px'
      el.style.opacity = '1'
      
      // Call done when transition completes
      setTimeout(done, 300)
    },
    afterEnter(el) {
      el.style.height = 'auto'
      el.style.transition = ''
    },
    beforeLeave(el) {
      // Set explicit height before starting leave transition
      el.style.height = el.offsetHeight + 'px'
      el.style.transition = ''
      // Force reflow
      el.offsetHeight
    },
    leave(el, done) {
      el.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out'
      el.style.height = '0'
      el.style.opacity = '0'
      
      setTimeout(done, 300)
    },
    afterLeave(el) {
      el.style.height = ''
      el.style.opacity = ''
      el.style.transition = ''
    }    
  }
}
